export default __webpack_public_path__ + "img/cd2a834c22dd2a2625039f7f85f55e64.svg";